import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon, InternalImage } from "app/NativeComponents/common";
class PartnerLogos extends Component {
  render() {
    var sourceUrl = "";
    var sourceIcon = "";
    var partnerUrl = "";
    var color = "";

    if (this.props.is_white) {
      sourceUrl = "/assets/images/DealMachineLogoWhite.svg";
      sourceIcon = "/assets/images/Icon-white.png";
      partnerUrl = this.props.partner_info.partner_logo_white;
      color = "#fff";
    } else {
      sourceUrl = "/assets/images/DealMachineLogo.svg";
      sourceIcon = "/assets/images/Icon-blue.png";
      partnerUrl = this.props.partner_info.partner_logo;
    }
    if (
      this.props.partner_info.partner_id != 0 &&
      this.props.partner_info.partner_id != "" &&
      this.props.partner_info.partner_promo !== this.props.user_info.promoText
    ) {
      return (
        <div className="dm-website-partner-logos">
          <img alt="" className="dm-website-navbar-logo" src={sourceUrl} />
          <span>
            <Icon icon="add" size={18} style={{}} color={color} />
          </span>
          <img
            alt=""
            className="dm-website-navbar-partner-logo"
            src={partnerUrl}
          />
        </div>
      );
    }

    return (
      <InternalImage
        style={{
          marginBottom: 0,
          width: this.props.size,
          marginLeft: 0,

          objectFit: "contain",
          alignItems: "center",
          justifyContent: "flex-start"
        }}
        contain
        image={sourceIcon}
      />
    );
  }
}

const mapStateToProps = ({ marketing }) => {
  const { partner_info, user_info } = marketing;

  return {
    partner_info,
    user_info
  };
};

export default connect(mapStateToProps, {})(PartnerLogos);
